import { COVERGO_SAAS_DEV } from "../consts.js"

export const williamrussell_dev = {
	"williamrussell-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "williamrussell_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}
